import { combineReducers } from '@reduxjs/toolkit'
import filters from './filtersSlice'

const reducer = combineReducers({
    filters,
})

export default reducer
